var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_860_24979)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.864 0.136225C13.4163 0.136225 13.864 0.583941 13.864 1.13622L13.864 24.8643C13.864 25.4165 13.4163 25.8643 12.864 25.8643C12.3117 25.8643 11.864 25.4165 11.864 24.8643L11.864 1.13622C11.864 0.583941 12.3117 0.136225 12.864 0.136225Z",
    fill: "#242730"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 13C26 13.5523 25.5523 14 25 14L1 14C0.447715 14 -1.95703e-08 13.5523 -4.37114e-08 13C-6.78526e-08 12.4477 0.447716 12 1 12L25 12C25.5523 12 26 12.4477 26 13Z",
    fill: "#242730"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_860_24979"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.630ff75c041b336555798f812daad88f.svg";
export { ForwardRef as ReactComponent };